import { usePreviewData } from 'framework-asset-preview-lib/internal/shared/providers/DataProvider';
export default function useCrmObject() {
  const {
    crmObject
  } = usePreviewData();
  return crmObject;
}